const GoogleAdsGenerateLead = (formName: string) => {
  if (window?.gtag && typeof window.gtag === 'function') {
    window.gtag('event', 'generate_lead', {
      form_name: formName
    });
  }
};
export default GoogleAdsGenerateLead;